import {Rule} from 'antd/lib/form';

export const initialValuesDft = {
    service: undefined,
    rules: [],
};

export const serviceRules: Rule[] = [
    {required: true, message: '请选择泳道入口服务'},
];
